import { render } from "./Spinners.vue?vue&type=template&id=6acf8404"
import script from "./Spinners.vue?vue&type=script&lang=js"
export * from "./Spinners.vue?vue&type=script&lang=js"

import "./Spinners.vue?vue&type=style&index=0&id=6acf8404&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__